/**
 * Created by zhoay on 2022/6/22
 * Desc: 毕业相册申请
 */
import React, { Component } from 'react'
import {List, Toast} from "antd-mobile";
import { fetchGet, fetchPost, fetchPostObj } from '../../../utils/fetchRequest'
import { API } from '../../../configs/api.config'
import { getSearchParams, isObjEmpty, getIntValue, getStrValue, } from '../../../utils/common'
import { Icon, message, Button, Cascader } from 'antd'
import './AlbumApply.css';
import {connect} from 'react-redux'

class AlbumApply extends Component {

    componentWillMount() {
        document.title = "相册申请";
    }

    constructor () {
        super()

        this.state = {
           appId: null,
           openId: null,
           schoolData: [],
           optionss: [],
           schoolName: null,
           gradeClazz: null,
           stuName: null,
           psPhone: null,
           cascaderValue:[]
        }
    }

    componentDidMount () {
        Toast.loading('努力加载中...', 0)
        this.getSchoolList()
        this.onChange()

        this.searchParams = getSearchParams(this.props.location.search)
        this.setState({
            appId: this.searchParams.appId,
            openId: this.searchParams.openId,
        })
    }

    render() {
        const {schoolData, optionss, schoolName, gradeClazz, stuName, psPhone} = this.state;

        return (
            <div style={{width: '100%'}}>
                <div className="common-album-layout" ref={node => this.node = node} onChange={this.handelValueCom} style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}}>
                    <div className='headerLayout'>支付完成，毕业相册将寄送到学校统一发放。</div>

                    <Cascader options={optionss} onChange={(value)=>this.changeCascader(value)} placeholder="请选择市/区" />

                    <div className="comhline_sty1"></div>

                    <div className="item_sty">
                        <div className="left_title">学校</div><div className={'form-input-fill'}>*</div>
                        <input ref='schoolName' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.schoolName}/>
                    </div>

                    <div className="comhline_sty1"></div>

                    <div className="item_sty">
                        <div className="left_title">班级</div><div className={'form-input-fill'}>*</div>
                        <input ref='gradeClazz' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.gradeClazz}/>
                    </div>

                    <div className="comhline_sty1"></div>

                    <div className="item_sty">
                        <div className="left_title">学生姓名</div><div className={'form-input-fill'}>*</div>
                        <input ref='stuName' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.stuName}/>
                    </div>

                    <div className="comhline_sty1"></div>

                    <div className="item_sty">
                        <div className="left_title">手机号</div>
                        <input ref='psPhone' className="text-right right_input" type="text" placeholder="默认电话" maxLength={20} autoFocus="autoFocus" value={this.state.psPhone}/>
                    </div>

                    <div className="comhline_sty"></div>

                    <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                            onClick={this.onNextClick}>下一步</Button>
                </div>
            </div>
        )
    }

  onChange = (value) => {

      fetchGet(API.GET_AREA_LIST, {
            // schoolId: this.props.userInfo.teacher.schoolId,
        }).then(response => {
            Toast.hide();
            const {optionss} = this.state;

            if (response && response.data) {
                // const schoolArray = response.data.schools
                const propertyArray = response.data;

               this.setState({
                   optionss: propertyArray
               })
            }

        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
      })
  }

  getSchoolList = () => {
      Toast.loading('', 0);

      fetchGet(API.SCHOOL_LIST, {
          // schoolId: this.props.userInfo.teacher.schoolId,
      }).then(response => {
          Toast.hide();
          const {schoolData} = this.state;
          schoolData.length = 0;
          if (response && response.data) {
              // const schoolArray = response.data.schools
              const propertyArray = response.data;

              if (!isObjEmpty(propertyArray)) {

                  propertyArray.forEach((hrObj, index) => {
                      if (hrObj) {
                          schoolData.push({
                              title: getStrValue(hrObj, 'schoolName'),
                              schoolId: getIntValue(hrObj, 'schoolId'),
                              schoolName: getStrValue(hrObj, 'schoolName'),
                          })
                      }
                  });

              }
          }

          this.setState({
              schoolData
          })
          console.log('schoolData', schoolData);
      }).catch(error => {
          Toast.hide();

          if (typeof error === 'string') {
              Toast.fail(error, 2)
          } else {
              Toast.fail('请求异常', 2)
          }
      })
  };

  changeCascader(value) {
    //this.getAreaSchoolList(value[0])
    this.setState({
        cascaderValue: value
    })
  };

  getAreaSchoolList = (value) => {
        Toast.loading('', 0);

        fetchGet(API.AREA_SCHOOL_LIST, {
            area: value,
        }).then(response => {
            Toast.hide();
            const {schoolData} = this.state;
            schoolData.length = 0;
            if (response && response.data) {
                // const schoolArray = response.data.schools
                const propertyArray = response.data;

                if (!isObjEmpty(propertyArray)) {

                    propertyArray.forEach((hrObj, index) => {
                        if (hrObj) {
                            schoolData.push({
                                title: getStrValue(hrObj, 'schoolName'),
                                schoolId: getIntValue(hrObj, 'schoolId'),
                                schoolName: getStrValue(hrObj, 'schoolName'),
                            })
                        }
                    });

                }
            }

            this.setState({
                schoolData
            })
            console.log('schoolData', schoolData);
        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

  onNextClick = () => {

      const {cascaderValue, optionss, schoolName, gradeClazz, stuName, psPhone, appId, openId } = this.state

    if (optionss.length<3) {
        Toast.fail('请输入省市区')
        return
    }
    if (isObjEmpty(schoolName)) {
        Toast.fail('请输入学校')
        return
    }
    if (isObjEmpty(stuName)) {
            Toast.fail('请输入班级')
            return
        }
    if (isObjEmpty(stuName)) {
        Toast.fail('请输入学生姓名')
        return
    }

    const paramObj = {
        optionss: cascaderValue,
        school_name: schoolName,
        gradeClazz: gradeClazz,
        stuName: stuName,
        parents_phone: psPhone,
    }

    fetchPostObj(API.POST_ALBUM_SAVE, paramObj,
        {"Content-Type": 'application/json;charset=UTF-8'})
        .then(response => {
        Toast.hide()
        if (response && response.data) {

           this.props.history.push('/albumPay/'+response.data.id +'/'+ appId +'/'+ openId);
        }

    }).catch(error => {
        Toast.hide()

        if (typeof error === 'string') {
            Toast.fail(error, 2)
        } else {
            Toast.fail('请求异常', 2)
        }
    })
  }

  handelValueCom = (event) => {
      //获取用户名的值
      let schoolName = this.refs.schoolName.value;
      let gradeClazz = this.refs.gradeClazz.value;
      let stuName = this.refs.stuName.value;
      let psPhone = this.refs.psPhone.value;
      //获得内容的值
      this.setState({
          schoolName: schoolName,
          gradeClazz: gradeClazz,
          stuName: stuName,
          psPhone: psPhone,
      })
  }

}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AlbumApply)

